/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// Libraries
import React from 'react';
import { object, string, shape } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '40px',
        fontSize: '13px',
        fontWeight: '600',
    },
});

const ProductsViewed = ({
    classes,
    productsViewedData,
}) => {
    const backgroundColor =  productsViewedData?.background_color || '#ff0';
    const fontColor =  productsViewedData?.fontColor || '#000';
    return (
         productsViewedData?.copy
    && (
        <div
            className={classes.root}
            style={{
                backgroundColor: `${backgroundColor}`,
                color: `${fontColor}`,
            }}
        >
            149 {productsViewedData.copy}
        </div>
    ));
};

ProductsViewed.propTypes = {
    classes: object.isRequired,
    productsViewedData: shape({
        background_color: string.isRequired,
        copy: string.isRequired,
        font_color: string.isRequired,
    }).isRequired,
};

export default withStyles(styles)(ProductsViewed);
